const Index = () => import('./index.vue');
const CreatePage = () => import('./_pages/create.vue');
const ViewPage = () => import('./_pages/view.vue');
const BalancesPage = () => import('./_pages/balances.vue');

export default [
    {
        path: '/suppliers',
        name: 'SuppliersPage',
        component: Index
    },
    {
        path: '/new-supplier',
        name: 'NewSupplierPage',
        component: CreatePage
    },
    {
        path: '/supplier/:id',
        component: ViewPage
    },
    {
        path: '/supplier/balances/:id',
        component: BalancesPage
    }
]